module.exports = __webpack_public_path__ + "static/media/chart.e0969052.jpg";